import { Notification, NotificationState } from './index';
import { NotificationMutations } from './mutations';
import { MattermostState } from '../mattermost';

import type { AVRoomState } from '../avroom/types';

import loggerService from '@/services/logger.service';

interface NotificationContext {
  state: NotificationState;
  rootState: {
    event: { avroom: AVRoomState; [j: string]: any };
    mattermost: MattermostState;
    [k: string]: any;
  };
  commit: <k extends keyof NotificationMutations>(mutation: k, payload?: any, config?: { root: boolean }) => any;
  dispatch: (action: string, payload?: any, root?: { root: boolean }) => Promise<any>;
}

export default {
  addMessage(context: NotificationContext, payload: { message: Notification }) {
    context.commit('setMessage', payload.message);
  },
  sendAnnouncement(context: NotificationContext, payload: { message: string }) {
    const channel_id = context.rootState.mattermost.publicChannels.townhall;
    if (channel_id) {
      context.dispatch(
        'event/avroom/postMessage',
        {
          channel_id,
          message: payload.message
        },
        { root: true }
      );
    } else {
      loggerService.warn('Not found townhall channel id');
    }
  }
};
